var _defs, _ellipse, _ellipse2, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacherBonusStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 410",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "starGold",
    x1: -70,
    y1: -110,
    x2: 60,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFC23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "starHighlight",
    x1: -80,
    y1: -80,
    x2: 85,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE42",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "heroGlow"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAB6",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F8E8FF",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "loop",
    x1: 100,
    y1: 100,
    x2: 670,
    y2: 400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFD890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCADF9"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 398,
    cy: 202,
    rx: 335,
    ry: 187,
    fill: "url(#heroGlow)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395,
    cy: 290,
    rx: 307,
    ry: 67,
    stroke: "url(#loop)",
    strokeWidth: 5,
    strokeDasharray: "2 14",
    strokeLinecap: "round",
    opacity: 0.82
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 178,
    r: 9,
    fill: "#C9A0F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651,
    cy: 131,
    r: 12,
    fill: "#FBD37B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 641,
    cy: 310,
    r: 7,
    fill: "#C09CF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 79,
    r: 6,
    fill: "#FFE0A0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567,
    cy: 70,
    r: 6,
    fill: "#B78BEC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "pa-bonus-sparkles"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(108 103) scale(1)",
    d: "M0 -18 Q3.24 -3.24 18 0 Q3.24 3.24 0 18 Q-3.24 3.24 -18 0 Q-3.24 -3.24 0 -18Z",
    fill: "#C79AF7"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(657 80) scale(1)",
    d: "M0 -18 Q3.24 -3.24 18 0 Q3.24 3.24 0 18 Q-3.24 3.24 -18 0 Q-3.24 -3.24 0 -18Z",
    fill: "#FFD06B"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(112 297) scale(0.55)",
    d: "M0 -18 Q3.24 -3.24 18 0 Q3.24 3.24 0 18 Q-3.24 3.24 -18 0 Q-3.24 -3.24 0 -18Z",
    fill: "#FFC86F"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(710 248) scale(0.6)",
    d: "M0 -18 Q3.24 -3.24 18 0 Q3.24 3.24 0 18 Q-3.24 3.24 -18 0 Q-3.24 -3.24 0 -18Z",
    fill: "#C7A0F5"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(213 44) scale(0.6)",
    d: "M0 -18 Q3.24 -3.24 18 0 Q3.24 3.24 0 18 Q-3.24 3.24 -18 0 Q-3.24 -3.24 0 -18Z",
    fill: "#FFD46D"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(595 355) scale(0.65)",
    d: "M0 -18 Q3.24 -3.24 18 0 Q3.24 3.24 0 18 Q-3.24 3.24 -18 0 Q-3.24 -3.24 0 -18Z",
    fill: "#FFD46D"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(474 35) scale(0.55)",
    d: "M0 -18 Q3.24 -3.24 18 0 Q3.24 3.24 0 18 Q-3.24 3.24 -18 0 Q-3.24 -3.24 0 -18Z",
    fill: "#CAA6F3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(288 351) scale(0.5)",
    d: "M0 -18 Q3.24 -3.24 18 0 Q3.24 3.24 0 18 Q-3.24 3.24 -18 0 Q-3.24 -3.24 0 -18Z",
    fill: "#C9A3FB"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(745 143) scale(0.45)",
    d: "M0 -18 Q3.24 -3.24 18 0 Q3.24 3.24 0 18 Q-3.24 3.24 -18 0 Q-3.24 -3.24 0 -18Z",
    fill: "#F3BD5D"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(237 231) rotate(-16) scale(0.61)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "pa-bonus-character"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cy: 105,
    rx: 72,
    ry: 13,
    fill: "#6F42BA",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81 24 Q-124 -4 -138 15 M82 22 Q115 -11 134 -7",
    fill: "none",
    stroke: "#D38B2D",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -139,
    cy: 14,
    r: 12,
    fill: "#FFECAC",
    stroke: "#F4BA4A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: -10,
    r: 12,
    fill: "#FFECAC",
    stroke: "#F4BA4A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28 77L-35 108 M28 77L35 108",
    stroke: "#BD833E",
    strokeWidth: 13,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -39,
    cy: 110,
    rx: 22,
    ry: 10,
    fill: "#8F54D7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36,
    cy: 110,
    rx: 22,
    ry: 10,
    fill: "#8F54D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -5.88,-91.29 Q 0,-104 5.88,-91.29 L 23.51,-53.16 Q 29.39,-40.45 43.29,-38.79 L 85.01,-33.8 Q 98.91,-32.14 88.64,-22.62 L 57.82,5.93 Q 47.55,15.45 50.27,29.19 L 58.41,70.4 Q 61.13,84.14 48.9,77.31 L 12.23,56.83 Q 0,50 -12.23,56.83 L -48.9,77.31 Q -61.13,84.14 -58.41,70.4 L -50.27,29.19 Q -47.55,15.45 -57.82,5.93 L -88.64,-22.62 Q -98.91,-32.14 -85.01,-33.8 L -43.29,-38.79 Q -29.39,-40.45 -23.51,-53.16 Z",
    fill: "#AE6B5D",
    opacity: 0.42,
    transform: "translate(0 7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -5.88,-91.29 Q 0,-104 5.88,-91.29 L 23.51,-53.16 Q 29.39,-40.45 43.29,-38.79 L 85.01,-33.8 Q 98.91,-32.14 88.64,-22.62 L 57.82,5.93 Q 47.55,15.45 50.27,29.19 L 58.41,70.4 Q 61.13,84.14 48.9,77.31 L 12.23,56.83 Q 0,50 -12.23,56.83 L -48.9,77.31 Q -61.13,84.14 -58.41,70.4 L -50.27,29.19 Q -47.55,15.45 -57.82,5.93 L -88.64,-22.62 Q -98.91,-32.14 -85.01,-33.8 L -43.29,-38.79 Q -29.39,-40.45 -23.51,-53.16 Z",
    fill: "url(#starGold)",
    stroke: "#F8B733",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -5.88,-91.29 Q 0,-104 5.88,-91.29 L 23.51,-53.16 Q 29.39,-40.45 43.29,-38.79 L 85.01,-33.8 Q 98.91,-32.14 88.64,-22.62 L 57.82,5.93 Q 47.55,15.45 50.27,29.19 L 58.41,70.4 Q 61.13,84.14 48.9,77.31 L 12.23,56.83 Q 0,50 -12.23,56.83 L -48.9,77.31 Q -61.13,84.14 -58.41,70.4 L -50.27,29.19 Q -47.55,15.45 -57.82,5.93 L -88.64,-22.62 Q -98.91,-32.14 -85.01,-33.8 L -43.29,-38.79 Q -29.39,-40.45 -23.51,-53.16 Z",
    fill: "url(#starHighlight)",
    opacity: 0.48,
    transform: "translate(-4 -2) scale(.93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67 -14 Q-18 -72 44 -67",
    stroke: "white",
    strokeOpacity: 0.68,
    strokeWidth: 7,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39 7 Q-27 -3 -15 7",
    stroke: "#4D2862",
    strokeWidth: 6,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 6,
    rx: 6.8,
    ry: 9.5,
    fill: "#4D2862"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 3,
    r: 2.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -36,
    cy: 26,
    rx: 12,
    ry: 6,
    fill: "#FF9E81",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36,
    cy: 26,
    rx: 12,
    ry: 6,
    fill: "#FF9E81",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18 34 Q0 56 18 34",
    stroke: "#6A2F62",
    strokeWidth: 5,
    strokeLinecap: "round",
    fill: "none"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(553 217) rotate(14) scale(0.71)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "pa-bonus-character"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cy: 105,
    rx: 72,
    ry: 13,
    fill: "#6F42BA",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81 24 Q-124 -4 -138 15 M82 22 Q115 -11 134 -7",
    fill: "none",
    stroke: "#D38B2D",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -139,
    cy: 14,
    r: 12,
    fill: "#FFECAC",
    stroke: "#F4BA4A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: -10,
    r: 12,
    fill: "#FFECAC",
    stroke: "#F4BA4A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28 77L-35 108 M28 77L35 108",
    stroke: "#BD833E",
    strokeWidth: 13,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -39,
    cy: 110,
    rx: 22,
    ry: 10,
    fill: "#8F54D7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36,
    cy: 110,
    rx: 22,
    ry: 10,
    fill: "#8F54D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -5.88,-91.29 Q 0,-104 5.88,-91.29 L 23.51,-53.16 Q 29.39,-40.45 43.29,-38.79 L 85.01,-33.8 Q 98.91,-32.14 88.64,-22.62 L 57.82,5.93 Q 47.55,15.45 50.27,29.19 L 58.41,70.4 Q 61.13,84.14 48.9,77.31 L 12.23,56.83 Q 0,50 -12.23,56.83 L -48.9,77.31 Q -61.13,84.14 -58.41,70.4 L -50.27,29.19 Q -47.55,15.45 -57.82,5.93 L -88.64,-22.62 Q -98.91,-32.14 -85.01,-33.8 L -43.29,-38.79 Q -29.39,-40.45 -23.51,-53.16 Z",
    fill: "#AE6B5D",
    opacity: 0.42,
    transform: "translate(0 7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -5.88,-91.29 Q 0,-104 5.88,-91.29 L 23.51,-53.16 Q 29.39,-40.45 43.29,-38.79 L 85.01,-33.8 Q 98.91,-32.14 88.64,-22.62 L 57.82,5.93 Q 47.55,15.45 50.27,29.19 L 58.41,70.4 Q 61.13,84.14 48.9,77.31 L 12.23,56.83 Q 0,50 -12.23,56.83 L -48.9,77.31 Q -61.13,84.14 -58.41,70.4 L -50.27,29.19 Q -47.55,15.45 -57.82,5.93 L -88.64,-22.62 Q -98.91,-32.14 -85.01,-33.8 L -43.29,-38.79 Q -29.39,-40.45 -23.51,-53.16 Z",
    fill: "url(#starGold)",
    stroke: "#F8B733",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -5.88,-91.29 Q 0,-104 5.88,-91.29 L 23.51,-53.16 Q 29.39,-40.45 43.29,-38.79 L 85.01,-33.8 Q 98.91,-32.14 88.64,-22.62 L 57.82,5.93 Q 47.55,15.45 50.27,29.19 L 58.41,70.4 Q 61.13,84.14 48.9,77.31 L 12.23,56.83 Q 0,50 -12.23,56.83 L -48.9,77.31 Q -61.13,84.14 -58.41,70.4 L -50.27,29.19 Q -47.55,15.45 -57.82,5.93 L -88.64,-22.62 Q -98.91,-32.14 -85.01,-33.8 L -43.29,-38.79 Q -29.39,-40.45 -23.51,-53.16 Z",
    fill: "url(#starHighlight)",
    opacity: 0.48,
    transform: "translate(-4 -2) scale(.93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67 -14 Q-18 -72 44 -67",
    stroke: "white",
    strokeOpacity: 0.68,
    strokeWidth: 7,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -27,
    cy: 6,
    rx: 6.8,
    ry: 9.5,
    fill: "#4D2862"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -29,
    cy: 3,
    r: 2.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 6,
    rx: 6.8,
    ry: 9.5,
    fill: "#4D2862"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 3,
    r: 2.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -36,
    cy: 26,
    rx: 12,
    ry: 6,
    fill: "#FF9E81",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36,
    cy: 26,
    rx: 12,
    ry: 6,
    fill: "#FF9E81",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18 34 Q0 56 18 34",
    stroke: "#6A2F62",
    strokeWidth: 5,
    strokeLinecap: "round",
    fill: "none"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400 189) rotate(1) scale(1.13)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "pa-bonus-character"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cy: 105,
    rx: 72,
    ry: 13,
    fill: "#6F42BA",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81 24 Q-124 -4 -138 15 M82 22 Q115 -11 134 -7",
    fill: "none",
    stroke: "#D38B2D",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -139,
    cy: 14,
    r: 12,
    fill: "#FFECAC",
    stroke: "#F4BA4A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: -10,
    r: 12,
    fill: "#FFECAC",
    stroke: "#F4BA4A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28 77L-35 108 M28 77L35 108",
    stroke: "#BD833E",
    strokeWidth: 13,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -39,
    cy: 110,
    rx: 22,
    ry: 10,
    fill: "#8F54D7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36,
    cy: 110,
    rx: 22,
    ry: 10,
    fill: "#8F54D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -5.88,-91.29 Q 0,-104 5.88,-91.29 L 23.51,-53.16 Q 29.39,-40.45 43.29,-38.79 L 85.01,-33.8 Q 98.91,-32.14 88.64,-22.62 L 57.82,5.93 Q 47.55,15.45 50.27,29.19 L 58.41,70.4 Q 61.13,84.14 48.9,77.31 L 12.23,56.83 Q 0,50 -12.23,56.83 L -48.9,77.31 Q -61.13,84.14 -58.41,70.4 L -50.27,29.19 Q -47.55,15.45 -57.82,5.93 L -88.64,-22.62 Q -98.91,-32.14 -85.01,-33.8 L -43.29,-38.79 Q -29.39,-40.45 -23.51,-53.16 Z",
    fill: "#AE6B5D",
    opacity: 0.42,
    transform: "translate(0 7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -5.88,-91.29 Q 0,-104 5.88,-91.29 L 23.51,-53.16 Q 29.39,-40.45 43.29,-38.79 L 85.01,-33.8 Q 98.91,-32.14 88.64,-22.62 L 57.82,5.93 Q 47.55,15.45 50.27,29.19 L 58.41,70.4 Q 61.13,84.14 48.9,77.31 L 12.23,56.83 Q 0,50 -12.23,56.83 L -48.9,77.31 Q -61.13,84.14 -58.41,70.4 L -50.27,29.19 Q -47.55,15.45 -57.82,5.93 L -88.64,-22.62 Q -98.91,-32.14 -85.01,-33.8 L -43.29,-38.79 Q -29.39,-40.45 -23.51,-53.16 Z",
    fill: "url(#starGold)",
    stroke: "#F8B733",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -5.88,-91.29 Q 0,-104 5.88,-91.29 L 23.51,-53.16 Q 29.39,-40.45 43.29,-38.79 L 85.01,-33.8 Q 98.91,-32.14 88.64,-22.62 L 57.82,5.93 Q 47.55,15.45 50.27,29.19 L 58.41,70.4 Q 61.13,84.14 48.9,77.31 L 12.23,56.83 Q 0,50 -12.23,56.83 L -48.9,77.31 Q -61.13,84.14 -58.41,70.4 L -50.27,29.19 Q -47.55,15.45 -57.82,5.93 L -88.64,-22.62 Q -98.91,-32.14 -85.01,-33.8 L -43.29,-38.79 Q -29.39,-40.45 -23.51,-53.16 Z",
    fill: "url(#starHighlight)",
    opacity: 0.48,
    transform: "translate(-4 -2) scale(.93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67 -14 Q-18 -72 44 -67",
    stroke: "white",
    strokeOpacity: 0.68,
    strokeWidth: 7,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -27,
    cy: 6,
    rx: 6.8,
    ry: 9.5,
    fill: "#4D2862"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -29,
    cy: 3,
    r: 2.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 6,
    rx: 6.8,
    ry: 9.5,
    fill: "#4D2862"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 3,
    r: 2.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -36,
    cy: 26,
    rx: 12,
    ry: 6,
    fill: "#FF9E81",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36,
    cy: 26,
    rx: 12,
    ry: 6,
    fill: "#FF9E81",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19 33 Q0 69 19 33 Z",
    fill: "#753153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 53 Q0 46 10 53",
    stroke: "#FF91A8",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherBonusStars);
export default __webpack_public_path__ + "static/media/teacherBonusStars.99bbc02442486da4925281514d179de2.svg";
export { ForwardRef as ReactComponent };